import TextTransformInput from './src/index'

TextTransformInput.install = function(Vue) {
  Vue.component(TextTransformInput.name, TextTransformInput)
}

export default TextTransformInput
